export default class Status{
    constructor(){
        this.success = false;
        this.message = "";
        this.result = null;
    }
}